import { render, staticRenderFns } from "./TableInspectionGroup.vue?vue&type=template&id=12d408d5&scoped=true"
import script from "./TableInspectionGroup.vue?vue&type=script&lang=js"
export * from "./TableInspectionGroup.vue?vue&type=script&lang=js"
import style0 from "./TableInspectionGroup.vue?vue&type=style&index=0&id=12d408d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d408d5",
  null
  
)

export default component.exports